import { render, staticRenderFns } from "./SessionDetailClue.vue?vue&type=template&id=36c1a05a&scoped=true&"
import script from "./SessionDetailClue.vue?vue&type=script&lang=js&"
export * from "./SessionDetailClue.vue?vue&type=script&lang=js&"
import style0 from "./SessionDetailClue.vue?vue&type=style&index=0&id=36c1a05a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1a05a",
  null
  
)

export default component.exports